<template>
<f7-page class="selection-view">
  <template #fixed>
    <app-navbar title="Dinner Menu"/>
  </template>

  <div class="menu-container">
    <f7-swiper class="menu-swiper"
        :allow-touch-move="false"
        :navigation="{
          prevEl: '.menu-nav-prev',
          nextEl: '.menu-nav-next'
        }">
      <f7-swiper-slide v-for="(m, midx) of menu" :key="midx">
        <f7-list no-hairlines no-hairlines-between>
          <f7-list-item class="title-item">{{ m.title }}</f7-list-item>

          <template v-for="(c, cidx) of m.categories" :key="cidx">
            <f7-list-item v-if="c.title" class="category-item">{{ c.title }}</f7-list-item>

            <f7-list-item v-for="(it, idx) of c.items" :key="idx"
                checkbox
                :value="`${midx}-${cidx}-${idx}`"
                :checked="isItemChecked(`${midx}-${cidx}-${idx}`)"
                @change="handleSelect">
              <div>
                <div class="item-title">{{ it.title }}</div>
                <div class="item-desc" v-if="it.desc">{{ it.desc }}</div>
                <div class="item-price" v-if="it.price">${{ it.price }}</div>
              </div>
            </f7-list-item>
          </template>
        </f7-list>
      </f7-swiper-slide>
    </f7-swiper>

    <div class="menu-nav">
      <f7-button class="menu-nav-prev" fill round>Last</f7-button>
      <f7-button class="menu-nav-next" fill round>Next</f7-button>
    </div>
  </div>

  <div class="order-container">
    <div class="order-section-title">Selections</div>
    <div class="order-section-content">
      <div class="order-list">
        <div class="order-item" v-for="(it, idx) of selectedItems" :key="idx">
          <div class="title">{{ it.title }}</div>
          <div class="price">
            <span v-if="it.price">${{ it.price }}</span>
          </div>
          <img src="@/assets/icons/delete.png" @click="deleteSelection(idx)">
        </div>
      </div>
      <div class="order-summary">
        <div class="total">
          <span class="unit">US$</span>
          <span class="number">{{ totalPrice.toFixed(2) }}</span>
        </div>
        <f7-button fill round @click="submit">Confirm</f7-button>
      </div>
    </div>
  </div>
</f7-page>
</template>

<script>
import { confirm } from '@/lib/helper'
import AppNavbar from '@/components/AppNavbar'
import data from '@/assets/data.json'

export default {
  components: { AppNavbar },

  props: {
    f7router: Object
  },

  data () {
    return {
      menu: data.menu,
      selectedIdx: []
    }
  },

  computed: {
    selectedItems () {
      return this.selectedIdx.map(it => {
        const [midx, cidx, idx] = it.split('-')
        return this.menu[midx].categories[cidx].items[idx]
      })
    },

    totalPrice () {
      return this.selectedItems.reduce((acc, it) => acc + (it.price || 0), 0)
    }
  },

  methods: {
    isItemChecked (idx) {
      return !!this.selectedIdx.find(it => it === idx)
    },

    handleSelect (ev) {
      if (ev.target.checked) {
        const prefix = ev.target.value.split('-')[0]
        const existIdx = this.selectedIdx.findIndex(it => it.startsWith(prefix))
        if (existIdx >= 0) { this.selectedIdx.splice(existIdx, 1) }
        this.selectedIdx.push(ev.target.value)
      } else {
        const removeIdx = this.selectedIdx.findIndex(it => it === ev.target.value)
        if (removeIdx >= 0) {
          this.selectedIdx.splice(removeIdx, 1)
        }
      }
    },

    deleteSelection (idx) {
      this.selectedIdx.splice(idx, 1)
    },

    submit () {
      confirm(
        'Tips',
        'Are you sure about the order? We will prepare the meal for you after you order.',
        () => { this.f7router.navigate('/success') }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.selection-view {
  .menu-container {
    position: absolute; left: 0; top: var(--f7-navbar-height);
    width: 100%; height: calc(70% - var(--f7-navbar-height));
    .menu-swiper {
      position: absolute; left: 80px; right: 80px; top: 50px; bottom: 100px;
      --f7-list-bg-color: transparent;
      --f7-list-margin-vertical: 0;
      --f7-checkbox-size: 25px;
      --f7-checkbox-border-width: 0;
      --f7-list-item-media-margin: 25px;
      :deep {
        .swiper-slide { overflow: auto; }
        .list { padding-bottom: 50px; }
        .icon-checkbox {
          background: url(~@/assets/icons/selectoff.png) no-repeat center / 100% 100%;
          &::before,
          &::after { display: none; }
        }
        label.item-checkbox input[type='checkbox']:checked ~ .icon-checkbox {
          background-image: url(~@/assets/icons/select.png);
        }
        .item-inner { justify-content: center; text-align: center; }
        .item-checkbox .item-inner > div { padding-right: 50px; }
      }
      .title-item { font-size: 22px; font-weight: bold; }
      .category-item { font-size: 19px; }
      .item-title { font-size: 19px; font-weight: bold; }
      .item-desc { font-size: 16px; color: #F4E3CB; }
      .item-price { font-size: 20px; font-weight: bold; }
    }
    .menu-nav {
      position: absolute; left: 0; bottom: 0;
      width: 100%; height: 150px;
      z-index: 10;
      background-image: url(~@/assets/images/mask.png);
      background-repeat: repeat-x;
      background-size: auto 100%;
      --f7-button-height: 36px;
      --f7-button-padding-horizontal: 20px;
      --f7-button-font-size: 18px;
      --f7-button-fill-text-color: var(--f7-theme-color);
      --f7-button-fill-bg-color: #403460;
      --f7-button-fill-hover-bg-color: #52427a;
      --f7-button-fill-pressed-bg-color: #2e2646;
      --f7-button-border-color: #403460;
      .button {
        position: absolute; bottom: 30px;
        &.swiper-button-disabled {
          opacity: 0.5;
          pointer-events: none;
          --f7-button-bg-color: transparent;
          --f7-button-border-width: 2px;
        }
      }
      &-prev { left: 180px; }
      &-next { right: 180px; }
    }
  }
  .order-container {
    position: absolute; left: 0; bottom: 0;
    width: 100%; height: 30%;
    background: linear-gradient(0deg, #3B2E5E 0%, #372C55 100%);
    box-sizing: border-box;
    padding: 60px;
    font-size: 20px;
    display: flex; flex-direction: column;
    .order-section-title {
      flex: 0 0 auto;
      font-size: 22px; font-weight: bold;
      margin-bottom: 50px;
    }
    .order-section-content {
      flex: 1 1 auto;
      overflow: hidden;
      display: flex;
    }
    .order-list {
      flex: 0 0 70%;
      overflow: auto;
      .order-item {
        display: flex; align-items: center;
        padding-right: 50px;
        &:not(:last-child) { margin-bottom: 20px; }
        .title {
          flex: 1 1 auto; margin-right: auto;
          white-space: nowrap; text-overflow: ellipsis; overflow: hidden;
        }
        .price { flex: 0 0 auto; font-weight: bold; margin-left: 20px; }
        img { flex: 0 0 auto; width: 20px; margin-left: 50px; }
      }
    }
    .order-summary {
      flex: 0 0 30%;
      display: flex; flex-direction: column; justify-content: space-between; align-items: flex-end;
      .total {
        font-weight: bold;
        display: flex; flex-direction: column-reverse; align-items: flex-end;
        .number { font-size: 30px; }
      }
    }
  }

  @include media-landscape {
    .menu-container {
      width: 70%; height: calc(100% - var(--f7-navbar-height));
    }
    .order-container {
      left: auto; right: 0; top: var(--f7-navbar-height); bottom: auto;
      width: 30%; height: calc(100% - var(--f7-navbar-height));
      padding: 40px;
      .order-section-content { flex-direction: column; }
      .order-list {
        flex: 1 1 auto;
        margin-bottom: 20px;
        .order-item { padding-right: 0; }
      }
      .order-summary {
        flex: 0 0 auto;
        flex-direction: row;
        align-items: center;
        .total {
          flex-direction: row;
          align-items: center;
          .unit { margin-right: 20px; }
          .number { font-size: 20px; }
        }
      }
    }
  }
}
</style>
